import { render, staticRenderFns } from "./mkt-pecas.vue?vue&type=template&id=94338c36&scoped=true&"
import script from "./mkt-pecas.vue?vue&type=script&lang=js&"
export * from "./mkt-pecas.vue?vue&type=script&lang=js&"
import style0 from "./mkt-pecas.vue?vue&type=style&index=0&id=94338c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94338c36",
  null
  
)

export default component.exports